import React, { useState } from 'react';
import './WhyYouWillLoveIt.css';
import ExpandingCard from '../../ExpandingCard/ExpandingCard';
import joinRebelsImage from '../../../assets/images/join-the-rebels-and-the-misfits.png';
import likeAMoshPitImage from '../../../assets/images/like-a-mosh-pit-for-all-the-arts.png';
import hypeIsCheapImage from '../../../assets/images/hype-is-cheap-support-isnt.png';
import { useIsMobile } from '../../../hooks/useIsMobile';

const cards = [
  {
    id: 1,
    title: "Join the rebels<br/>& misfits",
    subtitle: "And forget soulless scrolling.",
    description: "This is a space built for creatives, by creatives. Musicians, filmmakers, designers, performers, visionaries—find your people. Hype each other up. Make art. Break rules. This is your playground.",
    image: joinRebelsImage,
    isBlack: false
  },
  {
    id: 2,
    title: "Like a mosh pit<br/>for all the arts",
    subtitle: "Colliding in the best possible way.",
    description: "Why stick to one scene when you can throw yourself into all of them? Underground music to disruptive fashion. Here every creative world collides – loud, raw, and unapologetically original.",
    image: likeAMoshPitImage,
    isBlack: true
  },
  {
    id: 3,
    title: "hype is cheap,<br/>support isn't",
    subtitle: "Likes don't pay rent.",
    description: "Here, your support actually matters. Tip your favourite artists, buy their work, and fuel the creative chaos you want to see more of. Real art deserves more than just a fire emoji in the comments.",
    image: hypeIsCheapImage,
    isBlack: false
  }
];

const WhyYouWillLoveIt = () => {
  const [activeCard, setActiveCard] = useState(1);
  const isMobile = useIsMobile();

  const handleCardClick = (cardId) => {
    !isMobile && setActiveCard(cardId);
  };

  return (
    <section id="why-you-will-love-it-here" className="why-you-will-love-it-section">
      <div className="container">
        <h2>WHY YOU'LL LOVE IT HERE</h2>
        <div className="cards-container">
          {cards.map((card) => (
            <ExpandingCard
              key={card.id}
              title={card.title}
              subtitle={card.subtitle}
              description={card.description}
              image={card.image}
              isActive={!isMobile ? activeCard === card.id : true}
              onClick={() => handleCardClick(card.id)}
              isBlack={card.isBlack}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyYouWillLoveIt; 